// extracted by mini-css-extract-plugin
export var select = "_qi-0";